"use strict";
import { addEvent } from "./addEvent/addEvent";
import { breakPoints } from "./breakPoints/breakPoints";
import "./colorbox/jquery.colorbox-min.js?";
import "./colorbox/colorbox.scss";
import "./bxslider/jquery.bxslider.js";
// import "./bxslider/vendor/jquery.fitvids.js";
import "./bxslider/jquery.bxslider.scss";
import { mainMenu } from "./mainMenu/mainMenu";
import { mobileMainMenu } from "./mainMenu/mobileMainMenu";

import $ from "jquery";
window.jQuery = $;
window.$ = $;

$.event.special.touchstart = {
  setup: function (_, ns, handle) {
    this.addEventListener("touchstart", handle, { passive: true });
  },
};

document.addEventListener("DOMContentLoaded", DOMContentLoadedStart);
addEvent(window, "load", function () {
  afterLoadStart();
});

/*----- START FUNCTION -----*/
function DOMContentLoadedStart() {
  if (navigator.userAgent.match(/Android|webOS|iPhone|iPod|BlackBerry/i)) {
    $("body").addClass("mobil");
  }

  target_blank();
  powieksz_zdjecie();
  akceptacja_ciasteczka();
  facebook_box();
}

function afterLoadStart() {
  mainMenuInit();
  mainMenuMobileInit();
  baner_glowny(0);
  hasla_glowna();
  setTimeout(() => {
    setFooterHeight();
    //backgroundImagesShow();
  }, 0);
}

addEvent(window, "resize", function () {
  resize();
});

addEvent(window, "scroll", function () {
  scroll();
});

function resize() {
  setFooterHeight();
  mainMenuMobileInit();
  backgroundImagesShowHeight();
}

function scroll() {
  mainMenuPageScrolling();
}

/*----- CODE HERE -----*/

function target_blank() {
  $("a.out").attr("target", "blank");
}

/*----- BACKGROUND IMAGES SHOW -----*/

function backgroundImagesShow(index) {
  const mainContainer = "#background-images-show";
  const imgToSlidShow = $("body").attr("data-slids");
  const imgToSlidShowArray = imgToSlidShow.split(",");
  //let startElement = 0;
  const intervalTime = 10000;

  if (imgToSlidShowArray.length === 0) {
    return false;
  }

  backgroundImagesShowHeight();

  $(imgToSlidShowArray).each((i) => {
    const addElement = `
        <div class="img-container"
          style="
            background: url(${imgToSlidShowArray[i]}) no-repeat center center; 
            -webkit-background-size: cover;
            -moz-background-size: cover;
            -o-background-size: cover;
            background-size: cover;
            filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='${imgToSlidShowArray[i]}', sizingMethod='scale');
            -ms-filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='${imgToSlidShowArray[i]}', sizingMethod='scale');
          "
        >
        </div>
      `;

    $(mainContainer).append(addElement);
  });

  const slides = $(mainContainer).children();

  $(slides[index]).addClass("show");

  if (imgToSlidShowArray.length === 1) {
    return false;
  }
  /*
  setInterval(() => {
    let next = startElement + 1;
    if (next >= slides.length) {
      next = 0;
    }

    $(slides[next]).addClass("show");
    $(slides[startElement]).addClass("hide").removeClass("show");
    startElement = next;

    setTimeout(() => {
      $(mainContainer).find(".hide").removeClass("hide");
    }, 1100);
  }, intervalTime);
  */
}

function backgroundImagesShowSlide(index) {
  const mainContainer = "#background-images-show";
  const slides = $(mainContainer).children();

  $(slides).each(function () {
    //$(slides[prevIndex]).addClass("hide").removeClass("show");
  });

  $(mainContainer).find(".show").addClass("hide").removeClass("show");
  $(slides[index]).addClass("show").removeClass("hide");

  setTimeout(() => {
    $(mainContainer).find(".hide").removeClass("hide");
  }, 1100);
}

function backgroundImagesShowHeight() {
  if ($("body").hasClass("strona-glowna")) {
    return false;
  }
  const mainContainer = "#background-images-show";
  let $mainHeaderKontaktHeight = $(".main-header-kontakt").outerHeight(true);
  let $mainHeaderHeight = $(".main-header").outerHeight(true);
  let $mainArticleTitleHeight = $(".main-article-title").outerHeight(true);
  let $mainArticleTitleDiscriptionHeight = $(
    ".main-article-title-discription"
  ).outerHeight(true);

  if ($mainHeaderKontaktHeight == undefined) {
    $mainHeaderKontaktHeight = 0;
  }
  if ($mainHeaderHeight == undefined) {
    $mainHeaderHeight = 0;
  }
  if ($mainArticleTitleHeight == undefined) {
    $mainArticleTitleHeight = 0;
  }
  if ($mainArticleTitleDiscriptionHeight == undefined) {
    $mainArticleTitleDiscriptionHeight = 0;
  }

  let $heightContainer =
    $mainHeaderKontaktHeight +
    $mainHeaderHeight +
    $mainArticleTitleHeight +
    $mainArticleTitleDiscriptionHeight +
    20;

  $(mainContainer).height($heightContainer);
}

/*----- MAIN MENU -----*/
function mainMenuInit() {
  const mainMenuContainer =
    document.getElementsByClassName("main-nav-header")[0];
  new mainMenu(mainMenuContainer);
}

function mainMenuMobileInit() {
  const clientWidth = document.body.clientWidth;
  const mainMenuContainer =
    document.getElementsByClassName("main-nav-header")[0];
  const mobileMenu = new mobileMainMenu(mainMenuContainer);

  if (breakPoints().desktop >= clientWidth) {
    mobileMenu.enableMenu();
  } else {
    mobileMenu.disableMenu();
  }
}

function mainMenuPageScrolling() {
  let scroll = $(window).scrollTop();
  let topHeight = $(".main-header-kontakt").height();

  if (scroll >= topHeight + 30) {
    $("body").addClass("menu-stick");
  } else {
    if (scroll < topHeight) {
      $("body").removeClass("menu-stick");
    }
  }
}
/*----- WYSOKOSC FOOTER -----*/
function setFooterHeight() {
  $(".footer").css("min-height", "auto");

  const $wys_win = $(window).height();
  const $wys_wraper = $("#wrapper").outerHeight(true);
  const $wys_header = $(".main-header").outerHeight(true);
  const $wys_height_kontakt = $(".main-header-kontakt").outerHeight(true);
  const $footerPadding = $(".footer").innerHeight() - $(".footer").height();

  const $wys_decelowa_footer =
    $wys_win - $wys_wraper - $wys_header - $wys_height_kontakt - $footerPadding;

  if ($wys_decelowa_footer <= 0) {
    return;
  }
  $(".footer").css("min-height", $wys_decelowa_footer + "px");
}

/*----- POWIEKSZANIE ZDJEC -----*/
function powieksz_zdjecie() {
  const tab = $("a.powieksz");
  if (tab.length > 0) {
    $.colorbox.resize();
    $("a.powieksz").colorbox({
      initialWidth: 250,
      initialHeight: 125,
      maxWidth: "95%",
      maxHeight: "90%",
      onComplete: function () {
        var $title = $(this).attr("title");
        $("body").find("img.cboxPhoto").attr("alt", $title);
      },
    });
  }
}

/*----- BANER GLOWNY -----*/
function baner_glowny() {
  backgroundImagesShow(0);
  $(".bxslider-baner-glowny").each(function () {
    $(this).bxSlider({
      adaptiveHeight: true,
      autoHover: false,
      auto: true,
      pause: 7000,
      pager: false,
      responsive: true,
      controls: false,
      touchEnabled: false,
      onSlideBefore: function ($slideElement, oldIndex, newIndex) {
        console.log(newIndex);
        backgroundImagesShowSlide(newIndex);
      },
    });
  });
}

/*----- HASLA -----*/
function hasla_glowna() {
  $(".hasla-lista-bx").each(function () {
    $(this).bxSlider({
      adaptiveHeight: true,
      autoHover: true,
      auto: true,
      pause: 4000,
      pager: false,
      responsive: true,
      controls: false,
    });
  });
}

/*----- CIASTECZKA -----*/
function akceptacja_ciasteczka() {
  $.post("/ciasteczka", { akceptacja: -1 }, function (data) {
    if (data == 1) {
      $("div.ciasteczka-info").hide();
    }
  });
  $("div.ciasteczka-info a.akceptuje-ciasteczka").click(function () {
    $.post("/ciasteczka", { akceptacja: 1 }, function () { });
    $("div.ciasteczka-info").fadeOut();
    return false;
  });
}

function facebook_box() {
  $("div#facebook-box-pojemnik").mouseover(function (e) {
    $(this).stop().show().animate(
      {
        left: 0,
      },
      400
    );
  });

  $("div#facebook-box-pojemnik").mouseout(function (e) {
    $(this).stop().animate(
      {
        left: -302,
      },
      600
    );
  });
}
